"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SourceHoverButton = require("./SourceHoverButton");
Object.keys(_SourceHoverButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SourceHoverButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SourceHoverButton[key];
    }
  });
});